export default __webpack_public_path__ + "static/media/logo-dark.4cb36d62.png";